import React from "react";
import { Grid } from "@mui/material";
import { AlertBox } from "../Alert/Alert";

const ChooseSellerMessage = () => {
	return (
		<Grid item xs={12} lg={12} mb={4}>
			<AlertBox
				severity="error"
				message="No seller selected. Contact support@bezos.ai if you do not have access to a seller."
			/>
		</Grid>
	);
};

export default function SellerDependentView(props) {
	return (!props.seller) ? <ChooseSellerMessage /> : <>{props.children}</>;
}
